module.exports = __webpack_public_path__ + "static/media/Apercu-BoldItalic.f701918d.woff";